module.exports = __webpack_public_path__ + "static/media/car-bump.b00c2cea.svg";